<template>
  <div v-if="!products">
    loading...
  </div>
  <swiper
    v-else
    class="w-full h-auto mySwiper"
    :slides-per-view="perView"
    :centered-slides="false"
    :space-between="16"
    :navigation="true"
    :modules="modules"
  >
    <swiper-slide
      v-for="(product, idx) in products"
      :key="idx"
    >
      <product-list-item
        v-if="product"
        :product="product"
      />
    </swiper-slide>
  </swiper>
</template>
<script setup>
import ProductListItem from "@/components/ui/ProductListItem.vue";
import {Swiper, SwiperSlide} from "swiper/vue";
import {isDesktop} from "@/plugins/ScreenHelper.js";
import {Autoplay, Navigation} from "swiper/modules";
import {computed} from "vue";

defineProps({
  products: {
    type: Array,
    required: true,
    default: null
  }
})

const modules = isDesktop() ? [Autoplay, Navigation] : [Autoplay, Navigation];
const perView = computed(()=>isDesktop() ? 4.5 : 2.5);

</script>
<style>
:root {
  --swiper-navigation-color: #666;
  --swiper-theme-color: #666;
  --swiper-navigation-size: 22px;
}
.swiper-button-disabled{
  visibility: hidden;
}
</style>
